import Page from "./index";

export default { path: "/home/system/menu", component: Page };
